export class DocumentoDetalle{

	public DOCUMENT_DETAIL_ID: number;
	public DOCUMENT_ID: number;
	public ITEM_ID: number;
	public COMMENTS: string;
	public QUANTITY: number;
	public PRICE: number;
	public PERCENTAGE_DISCOUNT: number;
	public AMOUNT_DISCOUNT: number;
	public TOTAL: number;
	public DOCUMENT_DETAIL_TYPE: number;
	public TOTAL_GLOBAL_DISCOUNT: number;
	public PURCHASE_TOTAL: number;
	public AMOUNT_UTILITY: number;
	public PERCENTAGE_UTILITY: number;

	// Campos utilizados en la pantalla de agregar venta
	public identificador: number;
	public lstFamilia: any[];
    public lstSubfamilia: any[];
    public lstProducto: any[];
    public lstProductoFiltradas: any[];
    public ITEM_FAMILY_ID: number;
    public ITEM_SUBFAMILY_ID: number; 
    public CONTAINS_TAX: boolean;
    public searchProduct: string;
    public descuentoMontoBool: boolean;
	public descuentoPorcentajeBool: boolean;

	public BASE_PURCHASE_PRICE: number;
	public BASE_SALE_PRICE: number;

	public itemsShow: number;
	public arrayFilteredProd: any[];
	public filteredItemsShow: number;
	public isFilteredProd: boolean;

	public piezasContenedor: number;
	public allowDecimals: boolean;

	public contProduct: number;
	public contCargo: number;

	public STOCK: boolean;

	constructor(){
		this.DOCUMENT_DETAIL_ID = null;
		this.DOCUMENT_ID = null;
		this.ITEM_ID = null;
		this.COMMENTS = null;
		this.QUANTITY = null;
		this.PRICE = null;
		this.PERCENTAGE_DISCOUNT = null;
		this.AMOUNT_DISCOUNT = null;
		this.TOTAL = null;
		this.DOCUMENT_DETAIL_TYPE = null;
		this.TOTAL_GLOBAL_DISCOUNT = null;
		this.PURCHASE_TOTAL = null;
		this.AMOUNT_UTILITY = null;
		this.PERCENTAGE_UTILITY = null;

		this.identificador = null;
		this.lstFamilia = [];
		this.lstSubfamilia = [];
		this.lstProducto = [];
		this.lstProductoFiltradas = [];
		this.ITEM_FAMILY_ID = null;
		this.ITEM_SUBFAMILY_ID = null;
		this.CONTAINS_TAX = false;
		this.searchProduct = null;
		this.descuentoMontoBool = false;
		this.descuentoPorcentajeBool = false;

		this.BASE_PURCHASE_PRICE = null;
		this.BASE_SALE_PRICE = null;

		this.itemsShow = null;
		this.arrayFilteredProd = null;
		this.filteredItemsShow = null;
		this.isFilteredProd = null;

		this.piezasContenedor = null;
		this.allowDecimals = null;
	}

}


// WEBPACK FOOTER //
// ./src/app/models/DocumentoDetalle.ts